import {
  canViewKasi,
  canViewKabid,
  canViewSekdis,
  canViewKadis,
} from '../../../utils/roles/slidebar/default';

export const getLinkByUserRole = (user: User): string => {
  if (canViewKasi(user)) {
    return "#/pengesahan";
  }
  if (canViewKabid(user)) {
    return "#/pengesahan/kabid";
  }

  if (canViewSekdis(user)) {
    return "#/pengesahan/sekdis";
  }

  if (canViewKadis(user)) {
    return "#/pengesahan/kadis";
  }
  
  return "#/";
}